module.exports = __webpack_public_path__ + "static/paris-024-76508550a1c0cdb421f77fdf3d1c7e3b.jpg";